(() => {
  window.gdCareStoriesInit = scope => {
    scope.querySelectorAll('.gd-care-stories').forEach(section => {
      if (section.dataset.gdStoriesBound) return;
      const track = section.querySelector('[data-gd-stories-track]');
      const prev = section.querySelector('[data-gd-stories-prev]');
      const next = section.querySelector('[data-gd-stories-next]');
      const controls = section.querySelector('.gd-care-stories__controls');
      if (!track || !prev || !next || !controls) return;
      section.dataset.gdStoriesBound = 'true';

      const update = () => {
        const end = Math.max(0, track.scrollWidth - track.clientWidth);
        controls.hidden = end <= 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= end - 2;
        prev.hidden = prev.disabled;
        next.hidden = next.disabled;
      };
      const move = direction => {
        const cards = track.querySelectorAll('.gd-care-story');
        if (cards.length < 2) return;
        const step = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
        const end = Math.max(0, track.scrollWidth - track.clientWidth);
        const left = Math.max(0, Math.min(end, track.scrollLeft + direction * step));
        track.scrollTo({
          left,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      };

      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(update).observe(track);
      else window.addEventListener('resize', update, { passive: true });
      update();
    });
  };
})();